import { render, staticRenderFns } from "./AuthXForm.vue?vue&type=template&id=5319daac&scoped=true"
import script from "./AuthXForm.vue?vue&type=script&lang=js"
export * from "./AuthXForm.vue?vue&type=script&lang=js"
import style0 from "./AuthXForm.vue?vue&type=style&index=0&id=5319daac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5319daac",
  null
  
)

export default component.exports